import { omit } from "lodash";
import { IOfferAggRuleFormData, IOfferTarifficationFormData } from "../../context/types";
import { AggregationRule } from "../../../../lib/types/AggregationRule";
import { getServiceRatesBody } from "./getServiceRatesBody";
import { getRuleConditionBody } from "./getRuleConditionBody";

type Result = AggregationRule<"createObj">[] | undefined;

interface Props {
  tarifficationValues: IOfferTarifficationFormData;
  aggregationRulesValues: IOfferAggRuleFormData;
  fromDate: string;
}

/**
 * Получение массива AggregationRule для создания предложения
 * @param {Props} props - данные из формы
 * @return {Result}
 */

export const getAggregationRulesBody = (props: Props): Result => {
  const { fromDate, aggregationRulesValues, tarifficationValues } = props;
  const allServiceRates = getServiceRatesBody({
    tarifficationValues,
    fromDate,
    forAggregationRule: true,
  });
  const result: Result = aggregationRulesValues.aggregationRules
    ?.filter(
      ({ aggName, periodTypeId, rangeFrom }) =>
        !!aggName && !!periodTypeId && rangeFrom !== undefined
    )
    .map((item) => {
      const { rangeTo, id } = item;
      const aggName = item.aggName!; // Утверждение, т.к. выше в filter наличие значения проверено
      const periodTypeId = item.periodTypeId!; // Утверждение, т.к. выше в filter наличие значения проверено
      const rangeFrom = item.rangeFrom!; // Утверждение, т.к. выше в filter наличие значения проверено

      const ruleCondition = Array.isArray(item.ruleCondition)
        ? getRuleConditionBody(item.ruleCondition)
        : null;

      const serviceRates = allServiceRates
        ?.filter(({ aggregationRuleId }) => aggregationRuleId === id)
        .map((rate) => omit(rate, "aggregationRuleId"));

      const aggregationRule: AggregationRule<"createObj"> = {
        aggName,
        periodTypeId,
        rangeFrom,
        rangeTo,
        ruleCondition,
        serviceRates,
        fromDate,
      };
      return aggregationRule;
    });

  return result;
};
